// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"645":"b9f0e1d6","792":"be955764"}[chunkId] + ".js";
};